import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BodyTypeModalService {

  private selectedBodyTypeSubject = new BehaviorSubject<any>(null);
  public selectedBodyType$ = this.selectedBodyTypeSubject.asObservable();

  constructor() { }

  setSelectedBodyType(bodyType: any): void {
    this.selectedBodyTypeSubject.next(bodyType);
  }

  getSelectedBodyType(): any | null {
    return this.selectedBodyTypeSubject.value;
  }

  clearSelectedBodyType(): void {
    this.selectedBodyTypeSubject.next(null);
  }
}
